import { EmptyState } from '@brain/ui'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { ContainerList } from '../../components/ContainerList.tsx'
import { ThreeCol } from '../../components/ThreeCol.tsx'

export const Route = createFileRoute('/_app/projekte')({ component: Page })

function Page() {
  const { t } = useTranslation()
  return (
    <ThreeCol mobile="list" list={<ContainerList kind="project" />}>
      <div className="flex flex-1 items-center justify-center">
        <EmptyState title={t('empty.noSelection')} description={t('empty.noSelectionText')} />
      </div>
    </ThreeCol>
  )
}
